import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { academiaIncludes, academiaRows } from '../data/content';
import { Button } from './ui/Button';
import { Eyebrow, SectionTitle } from './ui/SectionHeading';
export function AcademiaComparison() {
  return <section className="border-y border-line bg-surface px-4 py-12 md:py-16" data-id="element-19" data-mp="2sm52qgicz7hd">
      <div className="mx-auto max-w-5xl" data-id="element-20" data-mp="2nkz7oc18784o">
        <Eyebrow data-id="element-21" data-mp="2ilw3ett2l5xr">🕊️ La opción que planifica tu año entero</Eyebrow>
        <SectionTitle data-id="element-22" data-mp="2io8upxkpwsnh">
          ¿Qué agrega la <span className="text-gold" data-id="element-23" data-mp="2duw3rgskg9rk">Academia 12 Meses?</span>
        </SectionTitle>
        <div className="mt-10 grid gap-4 md:grid-cols-2 md:gap-6" data-id="element-24" data-mp="29tkoo57bj6xm">
          <div className="rounded-2xl border border-line bg-ink p-6" data-id="element-25" data-mp="29u2kx1tzdl5j">
            <h3 className="mb-5 flex items-center gap-2 font-bold text-white" data-id="element-26" data-mp="24w0yq819d5pu">
              <XIcon aria-hidden="true" className="rounded-lg bg-red-500/15 p-2 text-red-400" size={40} data-id="element-27" data-mp="1zvwfwbcvnywg" />
              Sin la Academia
            </h3>
            <ul className="space-y-3" data-id="element-28" data-mp="1uymtz5op65dd">
              {academiaRows.map(([without]) => <li key={without} className="flex gap-2 text-sm font-medium text-zinc-400" data-id="element-29" data-mp="57kw3856dmh0">
                  <XIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-red-400" data-id="element-30" data-mp="a0x7ggkufwrt" />
                  {without}
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl border-2 border-gold bg-ink p-6" data-id="element-31" data-mp="aawx0rzhwfz">
            <h3 className="mb-5 flex items-center gap-2 font-bold text-white" data-id="element-32" data-mp="nz3ybcrdkwhz">
              <CheckIcon aria-hidden="true" className="rounded-lg bg-gold/15 p-2 text-gold" size={40} data-id="element-33" data-mp="sy6r9yu2zc9l" />
              Con la Academia
            </h3>
            <ul className="space-y-3" data-id="element-34" data-mp="e0o8dd433ta2">
              {academiaRows.map(([, withAcademia]) => <li key={withAcademia} className="flex gap-2 text-sm font-bold text-white" data-id="element-35" data-mp="iypnxo2axags">
                  <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-gold" data-id="element-36" data-mp="2ypve3sx116df" />
                  {withAcademia}
                </li>)}
            </ul>
          </div>
        </div>
        <div className="mt-8 rounded-2xl border border-gold/25 bg-ink p-6 text-center" data-id="element-37" data-mp="1a6zlh39v1ew5">
          <p className="text-sm font-extrabold uppercase tracking-[.14em] text-gold" data-id="element-38" data-mp="1597uqckybytj">
            La Academia incluye
          </p>
          <div className="mt-4 flex flex-wrap justify-center gap-2" data-id="element-39" data-mp="10fmuedvvysr6">
            {academiaIncludes.map(item => <span key={item} className="rounded-full border border-line bg-surface px-3 py-1.5 text-xs font-bold text-zinc-300" data-id="element-40" data-mp="qjjtfbcrt05t">
                {item}
              </span>)}
          </div>
          <div className="mt-7" data-id="element-41" data-mp="hjn89jplajfi">
            <Button href="#pricing" className="w-full text-xs md:w-auto md:text-sm" data-id="element-42" data-mp="ck0kigc4xksg">
              Quiero el Combo + Academia 12 Meses →
            </Button>
          </div>
        </div>
      </div>
    </section>;
}